<template>
  <div class="pageBox">
    <div class="pageBox_right">
      <span class="page_txt">{{ $t("ListofResults.Rowsperpage") }}:</span>
      <el-select
        v-model="sizePage"
        class="size_page"
        @change="selectCurrentItem"
        :style="{'color': $store.state.app.themeColor }" 
      >
        <el-option
          v-for="item in (isDialog ? dialogOptions : options)"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :style="{'color': item.value==sizePage?$store.state.app.themeColor:''}" 
        ></el-option>
      </el-select>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="sizePage"
        layout="prev, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <div v-show="false">compoment page index </div>
  </div>
</template>
<script>
export default {
  props: {
    totalFont: {
      type: Boolean,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    currentPage(val) {
      this.page = val;
    },
    pageSize(val) {
      this.sizePage = val;
    },
  },
  data() {
    return {
      page: this.currentPage,
      sizePage: this.pageSize,
      dialogOptions :[
        {
          value: 10,
          label: 10,
        },
        {
          value: 15,
          label: 15,
        },
      ],
      options: [
        {
          value: 5,
          label: 5,
        },
        {
          value: 10,
          label: 10,
        },
        {
          value: 15,
          label: 15,
        },
      ],
      token: localStorage.getItem("token"),
    };
  },

  // computed: {

  //   page: {
  //     get() {
  //       return this.currentPage
  //     },
  //     set(val) { this.$emit('update', val) }
  //   },
  //   isPagin: {
  //     get() {

  //       let status=localStorage.getItem('token')?false:true
  //       return status
  //     },
  //     set() {},
  //   },
  // },
  destroyed() {
    // bus.$off('handleShowLogin');
  },

  methods: {
    handleCurrentChange(val) {
      this.$emit("update:currentPage", val);
      this.$emit("onPageChange", { page: val, size: this.sizePage });
    },
    // onFirst() {
    //   this.page = 1
    //   this.handleCurrentChange(1)
    // },
    // onLast() {
    //   const page = Math.ceil(this.total / this.pageSize)
    //   this.page = page
    //   this.handleCurrentChange(page)
    // },

    //切换一页显示几条
    selectCurrentItem(val) {
      this.$emit("update:pageSize", val);
      this.$emit("onPageChange", { page: 1, size: val });
    },
  },
};
</script>
<style scoped>
.totalFont {
  line-height: 18px;
  font-size: 1.14285714rem;
  color: #8398bb;
}

.page_txt {
  color: #999999;
  flex-shrink: 0;
}
.size_page {
  margin-right: 20px;
}
.size_page /deep/ .el-input__inner {
  width: 60px;
  height: 24px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #cccccc;
  font-size: 1.14285714rem;
  padding-right: 0px !important;
  color: #009ea7;
}
.size_page /deep/ .el-icon-arrow-up:before {
  color: #999999;
  font-size: 1.14285714rem;
}
.el-select-dropdown__item {
  font-size: 1.14285714rem;
}
.size_page /deep/ .el-input__icon {
  width: 20px;
  line-height: 24px;
}
.firstBtn,
.lastBtn {
  width: 26px;
  height: 26px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e7eaed;
  font-size: 1.14285714rem;
}

button img {
  width: 10px;
  vertical-align: middle;
}
/* 分页 */
.pageBox /deep/ .el-pagination button,
.pageBox /deep/ .el-pagination button span:not([class*="suffix"]) {
  display: inline;
  min-width: 24px !important;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 1.14285714rem;
  border: 1px solid #cccccc;
}
.pageBox /deep/ .el-pagination {
  padding: 0;
}
.pageBox /deep/ .btn-prev {
  margin-right: 10px;
  padding-right: 6px;
}
.pageBox /deep/ .btn-next {
  padding-left: 6px;
}
.pageBox /deep/ .el-icon-arrow-right:before {
  content: "\eb6b";
}
.pageBox /deep/ .el-icon-arrow-left:before {
  content: "\eb6a";
}
.pageBox /deep/ .el-icon-arrow-right,
.pageBox /deep/ .el-icon-arrow-left {
  width: 100%;
  font-family: "iconfont" !important;
}
.new-content-right .pageBox /deep/ .el-icon-arrow-right,
.SourcSanctionsShow_dialog .pageBox /deep/ .el-icon-arrow-right {
  color: #f9722c;
}
.new-content-right .pageBox /deep/ .el-icon-arrow-left,
.SourcSanctionsShow_dialog .pageBox /deep/ .el-icon-arrow-left {
  color: #f9722c;
}
::v-deep .el-pagination button:disabled .el-icon-arrow-left,
::v-deep .el-pagination button:disabled .el-icon-arrow-right {
  border-color: #cccccc;
  color: #999999;
}
::v-deep .el-input__inner {
  color: inherit !important;
}
@media (max-width: 1920px) {
  .size_page {
    margin-right: 15px;
  }
  .pageBox /deep/ .btn-prev {
    margin-right: 7px;
    padding-right: 5px;
  }
  .pageBox /deep/ .btn-next {
    padding-left: 5px;
  }
}
@media (max-width: 1439px) {
  .size_page {
    margin-right: 10px;
  }
}
</style>
